import React, { useCallback, useState } from "react";
import { ModalContext } from "./modal.context";
import Modal from "../../components/Elements/Modal";

export const ModalProvider = ({ children }) => {
  const [modals, setModals] = useState([]);

  const removeModal = useCallback((id) => {
    setModals((prev) => prev.filter((modal) => modal.id !== id));
  }, []);

  return (
    <ModalContext.Provider value={{ modals, setModals }}>
      {children}
      {modals.map((modal) => (
        <Modal
          key={modal.id}
          id={modal.id}
          display={modal.display ?? true}
          size={modal.size}
          title={modal.title}
          fullMobile={modal.fullMobile}
          hiddeCloseButton={modal.hiddeCloseButton}
          icon={modal.icon}
          titleVariant={modal.titleVariant}
          headerClassName={modal.headerClassName}
          onCloseCallback={modal.onCloseCallback}
          onClose={() => {
            if (modal.onClose) modal.onClose();
            removeModal(modal.id);
          }}
        >
          {modal.content}
        </Modal>
      ))}
    </ModalContext.Provider>
  );
};
